import type { Template } from "@/types";

export const LA_07_H0_V7: Template[] = [
    {
        id: "la-07-h0v7-01",
        name: "LA 01 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 118, y: 52, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 245, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 267, y: 52, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 267, y: 245, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 52, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 416, y: 245, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 881, y: 52, width: 267, height: 379, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-02",
        name: "LA 02 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 168, y: 0, width: 339, height: 482, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 52, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 794, y: 245, width: 142, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 944, y: 52, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 944, y: 245, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 52, width: 141, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 245, width: 141, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-03",
        name: "LA 03 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 117, y: 34, width: 292, height: 415, rotation: 0, imageRotation: 0 },
            { id: "2", x: 417, y: 34, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 245, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 869, y: 34, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 869, y: 245, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 34, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 245, width: 140, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-04",
        name: "LA 04 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 193, y: 34, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 193, y: 245, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 341, y: 34, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 341, y: 245, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 793, y: 34, width: 292, height: 415, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 34, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 245, width: 142, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-05",
        name: "LA 05 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 138, y: 50, width: 265, height: 382, rotation: 0, imageRotation: 0 },
            { id: "2", x: 410, y: 50, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 410, y: 245, width: 129, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 828, y: 50, width: 276, height: 382, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1112, y: 50, width: 89, height: 122, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1112, y: 180, width: 89, height: 122, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1112, y: 309, width: 89, height: 123, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-06",
        name: "LA 06 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 162, y: 73, width: 233, height: 338, rotation: 0, imageRotation: 0 },
            { id: "6", x: 402, y: 73, width: 114, height: 165, rotation: 0, imageRotation: 0 },
            { id: "7", x: 402, y: 245, width: 114, height: 165, rotation: 0, imageRotation: 0 },
            { id: "2", x: 867, y: 35, width: 142, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 867, y: 245, width: 142, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 35, width: 143, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 245, width: 143, height: 203, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-07",
        name: "LA 07 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "2", x: 194, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 388, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "4", x: 583, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "5", x: 777, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "6", x: 971, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1165, y: 103, width: 187, height: 277, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-08",
        name: "LA 08 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 42, y: 31, width: 304, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 354, y: 31, width: 304, height: 419, rotation: 0, imageRotation: 0 },
            { id: "3", x: 665, y: 31, width: 304, height: 419, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 31, width: 162, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 245, width: 162, height: 206, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1146, y: 31, width: 164, height: 206, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1146, y: 245, width: 164, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-09",
        name: "LA 09 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 64, y: 0, width: 177, height: 238, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 245, width: 177, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 249, y: 0, width: 177, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 249, y: 245, width: 177, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 434, y: 0, width: 178, height: 238, rotation: 0, imageRotation: 0 },
            { id: "6", x: 434, y: 245, width: 178, height: 238, rotation: 0, imageRotation: 0 },
            { id: "7", x: 843, y: 0, width: 342, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-10",
        name: "LA 10 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h0_v7_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 123, y: 52, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 123, y: 245, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 269, y: 52, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 269, y: 245, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 415, y: 52, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 415, y: 245, width: 139, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 880, y: 52, width: 269, height: 379, rotation: 0, imageRotation: 0 }
        ],
    }
];